import { render, staticRenderFns } from "./ServerContent.vue?vue&type=template&id=052770d0&scoped=true&"
import script from "./ServerContent.vue?vue&type=script&lang=js&"
export * from "./ServerContent.vue?vue&type=script&lang=js&"
import style0 from "./ServerContent.vue?vue&type=style&index=0&id=052770d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052770d0",
  null
  
)

export default component.exports